import { Metrics } from '../../../../api/api-metrics';
import Payments from '../../../../api/api-payments';
import { logError } from './logging-service';

export const fetchIdentitySession = (SSOid, accessToken) => {
  return new Promise((resolve, reject) => {
    Payments.getIdentitySession(SSOid, accessToken, (response) => {
      if (response?.error || response?.statusCode >= 400) {
        logError(
          'identity-verification-service.fetchIdentitySession',
          response
        );
        reject(response);
        return;
      }

      resolve(response);
    });
  });
};

export const createIdentitySession = (SSOid, accessToken, payload) => {
  return new Promise((resolve, reject) => {
    Payments.createIdentitySession(SSOid, accessToken, payload, (response) => {
      if (response?.error || response?.statusCode >= 400) {
        logError(
          'identity-verification-service.createIdentitySession',
          response
        );
        reject(response);
        return;
      }
      resolve(response);
    });
  });
};

export const fetchIDVInfo = (accessToken, payload) => {
  return new Promise((resolve, reject) => {
    Metrics.identityVerification(payload, accessToken, (response) => {
      if (response?.error || response?.statusCode >= 400) {
        logError('identity-verification-service.fetchIDVInfo', response);
        reject(response);
        return;
      }
      resolve(response?.data);
    });
  });
};
